module.exports = __webpack_public_path__ + "static/media/ftmbg.29a16973.jpg";